import { LucideIcon } from 'lucide-react';
import { Alert, Button } from '@bliks-io/ui';

interface StatusActionAlertProps {
  /**
   * Icon component to display in the alert and button
   */
  icon: LucideIcon;

  /**
   * Message to display in the alert
   */
  message: string;

  /**
   * Button label text
   */
  buttonLabel: string;

  /**
   * Click handler for the action button
   */
  onAction: () => void;

  /**
   * Whether the action is currently loading
   */
  loading?: boolean;

  /**
   * Alert variant (default or destructive)
   */
  variant?: 'default' | 'destructive';

  /**
   * Button variant
   */
  buttonVariant?:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'destructive'
    | 'outline'
    | 'ghost'
    | 'link'
    | 'primary-light';
}

/**
 * Reusable alert component for status-specific actions
 * Used in OrgMemberFormDialog for send invitation, suspend, and unsuspend actions
 */
export function StatusActionAlert({
  icon: Icon,
  message,
  buttonLabel,
  onAction,
  loading = false,
  variant,
  buttonVariant
}: StatusActionAlertProps) {
  return (
    <Alert variant={variant} className="[&>svg]:static [&>svg]:inline [&>svg]:mr-2">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <Icon className="h-4 w-4 shrink-0" />
          <span className="text-sm">{message}</span>
        </div>
        <Button
          type="button"
          size="small"
          variant={buttonVariant}
          onClick={onAction}
          loading={loading}
          className="shrink-0"
        >
          <Icon className="h-4 w-4 mr-2" />
          {buttonLabel}
        </Button>
      </div>
    </Alert>
  );
}
